import { createSlice } from '@reduxjs/toolkit';

export const propertyManagerSlice = createSlice({
    name: 'propertyManager',
    initialState: {
        totalActiveUnits: 0,
        totalPortfolioUnits: 0,
        penetrationRate: 0,
        propertyInfo: [],
        propertyData: [],
        billingInfo: {
            currentTier: '',
            nextBillDate: '',
            estimatedAmount: 0,
        },
        paymentHistory: [],
        paymentMethodSetup: false,
        error: '',
    },
    reducers: {
        updateDashboard: (state, action) => {
            state.totalActiveUnits = action.payload.totalSubscriberCount;
            state.totalPortfolioUnits = action.payload.totalPortfolioUnits;
            state.penetrationRate = ((action.payload.totalSubscriberCount / action.payload.totalPortfolioUnits) * 100).toFixed(2);
            state.propertyInfo = action.payload.propertyPortfolioList;
        },
        updatePropertyData: (state, action) => {
            state.propertyData = action.payload.propertyCustomerList;
        },
        updateBilling: (state, action) => {
            state.billingInfo = action.payload.billingInfo;
            state.paymentHistory = action.payload.paymentHistory;
            state.paymentMethodSetup = action.payload.paymentMethodSetup;
        },
        clearPropertyManagerData: (state) => {
            state.totalActiveUnits = 0;
            state.totalPortfolioUnits = 0;
            state.penetrationRate = 0;
            state.propertyInfo = [];
            state.properties = [];
            state.billingInfo = { currentTier: '', nextBillDate: '', estimatedAmount: 0 };
            state.paymentHistory = [];
            state.paymentMethodSetup = false;
            state.error = '';
        },
        setPropertyManagerError: (state, action) => {
            state.error = action.payload.error;
        },
        getDashboardData: () => {},
        getPropertyData: () => {},
        getBillingData: () => {},
    },
});

export const {
    updateDashboard,
    updatePropertyData,
    updateBilling,
    clearPropertyManagerData,
    setPropertyManagerError,
    getDashboardData,
    getPropertyData,
    getBillingData,
} = propertyManagerSlice.actions;

export default propertyManagerSlice.reducer;
